<form [formGroup]="form()">
  @let controls = form().controls;
  <div class="address">
    <onyx-icon-box
      class="bar-icon"
      color="white"
      [size]="20"
      [hasShadow]="true"
    >
      <onyx-icon name="location-filled" [size]="14"></onyx-icon>
    </onyx-icon-box>

    <onyx-form-group [controls]="controls.address">
      <onyx-address-input
        [formControl]="controls.address"
        label="labels.address"
        [types]="[OnyxAddressType.POINT_OF_INTEREST, OnyxAddressType.CUSTOM]"
        [size]="32"
        [showAddOption]="true"
        [showApartment]="true"
        apartmentWidth="calc(4/12 * 100% - 12px)"
        [gap]="16"
        [showErrors]="false"
        [emptyAddressOptions]="addressEmptyOptions()"
        (addOption)="addPointOfInterest($event)"
      ></onyx-address-input>

      <onyx-suggestions
        [control]="controls.address"
        [suggestions]="addressSuggestions()"
      ></onyx-suggestions>
    </onyx-form-group>
  </div>

  @let timeWindowsGroup = controls.timeWindows;
  <div class="time-windows" [formGroup]="timeWindowsGroup">
    <onyx-icon-box
      class="bar-icon"
      color="white"
      [size]="20"
      [hasShadow]="true"
    >
      <onyx-icon name="clock-filled" [size]="14"></onyx-icon>
    </onyx-icon-box>

    <onyx-timepicker
      class="service-time"
      [formControl]="controls.serviceTime"
      [label]="serviceTimeLabel()"
      hint="labels.includeWaitingTime"
      variant="duration"
      [size]="32"
    ></onyx-timepicker>

    @let timeWindowsControls = timeWindowsGroup.controls;
    <onyx-form-group
      class="time-window-type"
      [controls]="timeWindowsControls.type"
    >
      <onyx-dropdown
        [formControl]="timeWindowsControls.type"
        [label]="timeWindowTypeLabel()"
        [options]="timeWindowTypes$ | async"
        [size]="32"
      ></onyx-dropdown>

      <onyx-suggestions
        [control]="timeWindowsControls.type"
        [suggestions]="timeWindowTypesSuggestions$ | async"
      ></onyx-suggestions>
    </onyx-form-group>

    <div class="windows">
      @for (control of timeWindowsFormArray().controls; track control) {
        <app-order-point-time-window-form
          [form]="control"
          [category]="pointCategory()"
          [serviceTime]="serviceTime()"
          [first]="$first"
          [last]="$last"
          [type]="timeWindowType()"
          [pointOfInterest]="pointOfInterest()"
          [isCompleted]="isCompleted()"
          (add)="addTimeWindow()"
          (remove)="removeTimeWindow($index)"
        ></app-order-point-time-window-form>
      }
    </div>
  </div>

  @if (!disabled()) {
    @if (showAfterHoursWarning(); as time) {
      <onyx-message class="fix-warning" intent="warning">
        <onyx-icon name="alert-circle-two-tone-filled" [size]="20"></onyx-icon>

        <p
          [innerHTML]="
            `${I18N}.afterBusinessHoursWarning`
              | translate: { time: time | onyxTime }
          "
        ></p>

        <p description>
          @if (pointOfInterest()?.businessHours; as businessHours) {
            {{ businessHours | businessHours }}
          }
        </p>
      </onyx-message>
    }

    @if (showPastDateWarning()) {
      <onyx-message class="fix-warning" intent="warning">
        <onyx-icon name="alert-circle-two-tone-filled" [size]="20"></onyx-icon>

        {{ `${I18N}.dateFromThePastWarning` | translate }}

        <p description>
          {{ `${I18N}.dateFromThePastWarningDescription` | translate }}
        </p>
      </onyx-message>
    }
  }
</form>
